module.exports = __webpack_public_path__ + "img/hazratMasoome.ce94d216.png";